import React from "react";
import { useContent } from "../../content/ContentContext";

export const HowWeWork = () => {
  const c = useContent("how");
  const options = Array.isArray(c.options) ? c.options : [];
  return (
    <section data-testid="how-section" className="sc-section">
      <div className="sc-container">
        <div className="max-w-2xl">
          <span className="sc-eyebrow">{c.eyebrow}</span>
          <h2 className="sc-h2 mt-3" data-testid="how-heading">{c.heading}</h2>
          <p className="sc-lede mt-5">{c.supporting}</p>
        </div>

        <ol className="mt-14 grid grid-cols-1 sm:grid-cols-2 gap-x-10 gap-y-10 md:gap-y-14">
          {options.map((o, i) => (
            <li key={i} className="flex gap-6 md:gap-7 items-start" data-testid={`how-option-${i}`}>
              <span className="font-serif text-4xl md:text-5xl text-gold leading-none shrink-0 mt-1">
                {o.n}
              </span>
              <div>
                <h3 className="sc-h3">{o.title}</h3>
                <p className="sc-body mt-2 max-w-md">{o.body}</p>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
};

export default HowWeWork;
